/**
 * Prototype preview pages (Catalog, Reports, …) — **local only**.
 *
 * Enabled only in Vite DEV when `VITE_PREVIEW_PAGES_ENABLED=true`
 * (explicit opt-in in `.env.local`). Never in production builds
 * (`import.meta.env.DEV` is false).
 *
 * Branches, Merge Requests, and Deployment Packages are real routes — not gated by this flag.
 */
export const IS_PREVIEW_PAGES_ENABLED =
	import.meta.env.DEV && import.meta.env.VITE_PREVIEW_PAGES_ENABLED === 'true'

/**
 * AI Agents preview page — code stays in the tree; chrome + route stay off
 * until this is flipped (still requires {@link IS_PREVIEW_PAGES_ENABLED}).
 */
export const IS_AI_AGENTS_PREVIEW_ENABLED = false
